// ============================================================
// Yerel depo adaptörü
//
// Mutasyon günlüğünü tarayıcının localStorage'ında tutar.
// Firestore kurulana kadar varsayılan depo budur; kalıcılık
// tek cihazla sınırlıdır ama sayfa yenilendiğinde veri kaybolmaz.
// ============================================================

const KEY = "minikpanel.mutations";
const ESKI_KEY = "minikampus.mutations";   // MinikPanel öncesi ad
const SINIR = 5000;   // günlük bu sayıyı aşarsa en eskiler düşer

export function localAdapter() {
  let onbellek = null;

  const oku = () => {
    if (onbellek) return onbellek;
    try {
      // Ad değişikliğinden önce kuyruğa girmiş ama henüz senkronlanmamış
      // mutasyonlar düşmesin diye eski anahtar bir kereye mahsus taşınır.
      const eski = localStorage.getItem(ESKI_KEY);
      if (eski !== null && localStorage.getItem(KEY) === null) {
        localStorage.setItem(KEY, eski);
        localStorage.removeItem(ESKI_KEY);
      }
      onbellek = JSON.parse(localStorage.getItem(KEY)) ?? [];
    } catch {
      onbellek = [];
    }
    return onbellek;
  };

  const yaz = liste => {
    try {
      localStorage.setItem(KEY, JSON.stringify(liste));
      return null;
    } catch {
      return "Tarayıcı depolama alanı dolu — değişiklikler yalnızca bu oturumda saklanıyor.";
    }
  };

  return {
    ad: "local",
    canli: false,       // gerçek zamanlı dinleme yok

    async yukle() {
      return oku();
    },

    async ekle(mutasyon) {
      const liste = oku();
      liste.push(mutasyon);
      if (liste.length > SINIR) liste.splice(0, liste.length - SINIR);
      return yaz(liste);
    },

    async temizle() {
      onbellek = [];
      try { localStorage.removeItem(KEY); } catch { /* depolama kapalı */ }
    },
  };
}
